const ES = {
    title: 'Usuarios',
    table: {
        title: 'Listado de usuarios',
        columns: {
            id: 'ID',
            fullname: 'Nombre',
            created: 'Alta',
            document: 'INE',
            email: 'Correo',
            role: 'Rol',
            status: 'Estado',
            actions: 'Acciones'
        },
        status: {
            1: 'Pendiente',
            2: 'Activo',
            3: 'Recupero',
            4: 'Bloqueado',
            5: 'Inactivo',
            'admin.natura': 'Administrador',
            'operator.natura': 'Operador',
            'ext-support-operator.natura': 'Operador Externo',
            'fraud_prevention_analyst.natura': 'Operador de prevención de fraude',
            'fraud_prevention_admin.natura': 'Administrador de prevención de fraude',
            'user_admin.natura': 'Administrador de Usuarios',
            'customer.natura': 'Cliente',
        },
        documentTypes: {
            dni: 'INE',
            cpf: 'CPF',
            ci_paraguay: 'CI Paraguay',
        },
        filter: {
            0: {
                title: 'Estado',
                0: 'Pendiente',
                1: 'Activo',
                2: 'Recupero',
                3: 'Bloqueado',
                4: 'Inactivo',
            },
            1: {
                title: 'Rol',
                0: 'Administrador',
                1: 'Operador',
                2: 'Operador Externo'
            }
        },
        menu: {
            add: {
                title: 'Agregar usuario',
                inputs: {
                    documentType: {
                        label: 'Tipo',
                        error: 'Por favor, seleccione un tipo de documento.'
                    },
                    document: {
                        label: 'INE',
                        placeholder: 'Ingresa INE',
                        error: 'Por favor, ingrese un {{type}} válido.'
                    },
                    name: {
                        label: 'Nombre',
                        placeholder: 'Ingresá nombre',
                        error: 'Por favor, ingrese un nombre.'
                    },
                    surname: {
                        label: 'Apellido',
                        placeholder: 'Ingresá apellido',
                        error: 'Por favor, ingrese un apellido.'
                    },
                    email: {
                        label: 'Correo',
                        placeholder: 'Ingresá correo',
                        error: 'Por favor, ingrese un email valido.'
                    },
                    role: {
                        label: 'Rol',
                        placeholder: 'Seleccioná un rol',
                        error: 'Por favor, seleccione un rol.'
                    }
                },
                submit: 'Aplicar',
                success: 'El usuario se creo correctamente.'
            },
            edit: {
                title: 'Editar usuario',
                inputs: {
                    fullname: {
                        label: 'Nombre y apellido',
                        placeholder: 'Editar nombre y apellido...',
                        error: 'Por favor, ingrese el nombre y apellido.'
                    },
                    email: {
                        label: 'Correo',
                        placeholder: 'Editar correo...',
                        error: 'Debes ingresar un correo válido para continuar'
                    },
                    role: {
                        label: 'Roles',
                        placeholder: 'Selecciona un rol',
                        error: 'Por favor, ingrese un rol.'
                    }
                },
                success: 'El usuario se edito correctamente.',
                alerts: {
                    emailSuccess: {
                        title: 'Enviamos un correo a {{email}}.',
                        description: 'El cliente tiene 24 hs. para ingresar y hacer la verificación que allí se solicita.'
                    },
                    emailError: {
                        title: 'El correo {{email}}',
                        description: 'no está disponible para ser usado por este cliente.\nSolicite otro correo.'
                    },
                    roleSuccess: 'Se ha modificado con éxito el usuario {{fullname}}'
                }
            },
            unsubscribe: {
                title: 'Baja usuario',
                modal: {
                    title: 'Desea dar de baja al usuario',
                    date: 'Fecha',
                    success: 'El cliente se elimino correctamente.'
                }
            },

        }
    }
};

export default ES;
